$(function () {

  var $content = $("#blog-grid");
  var $loader = $("#post-loader");
  var ppp = 4;

  var $loaderText = $("#post-loader-text");

  var offset = $content.find(".blog-tile").length + 1;

  console.log(offset);

  $loader.on('click', load_ajax_posts);

  function load_ajax_posts() {
    console.log("Loading Posts");

    if (!($loader.hasClass('post_loading_loader') || $loader.hasClass('post_no_more_posts'))) {
      $.ajax({
        type: 'POST',
        dataType: 'html',
        url: loading_vars.ajaxurl,
        data: {
          'ppp' : ppp,
          'offset' : offset,
          'post_type' : 'post',
          'action' : 'cc_more_post_ajax'
        },
        beforeSend: function() {
          $(".loading-indicator").removeClass("hide-indicator");
          $loader.hide();
        },
        success: function(data) {
          console.log("Loaded Posts");
          var $data = $(data);
          if ($data.length) {
            var $newElements = $data;

            $content.append($newElements).packery("appended", $newElements);


            masonryGridSizer($content);
            // $content.append($newElements);
            // $newElements.animate({opacity: 1});

            $loader.show();
            $(".loading-indicator").addClass("hide-indicator");
          } else {
            $loader.removeClass('post_loading_loader').addClass('post_no_more_posts').html(loading_vars.noposts);
            $(".loading-indicator").addClass("hide-indicator");

          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
        },
      });

    }

    offset += ppp;
    return false;

  }


});
